import OriginForm from './form';
import FormItem from './item';
import useForm from './useForm';

import type { FormProps } from './form';
import type { FormItemProps } from './item';
import type { UseFormRes, FormValue, FormErrors } from './useForm';

type CompoundedComponent = typeof OriginForm & {
  Item: typeof FormItem;
  useForm: typeof useForm;
};

const Form = OriginForm as CompoundedComponent;
 
Form.Item = FormItem;
Form.useForm = useForm;

export type { FormProps, FormItemProps, UseFormRes, FormValue, FormErrors };

export default Form;

